import osisConverters from './osisConversions';
import { buildPlansPath, resolvePlanName } from './planPaths';

export const SITE_ORIGIN = 'https://www.ai-bible.com';

export function normalizePathname(pathname = '') {
    if (!pathname || pathname === '/') return '/';

    const collapsed = `${pathname}`.replace(/\/+/g, '/');
    const trimmed = collapsed.replace(/\/+$/g, '') || '/';

    if (trimmed === '/') return '/';

    if (/^\/read\/[^/]+$/.test(trimmed)) {
        return `${trimmed}/`;
    }

    return trimmed;
}

export function buildCanonicalUrl(pathname = '') {
    const normalizedPath = normalizePathname(pathname);
    return `${SITE_ORIGIN}${normalizedPath}`;
}

export function buildReadPath(osisRange = '') {
    return osisConverters.toWebReadPath(osisRange);
}

export function deriveLegacyCanonicalPath(pathname = '', search = '') {
    if (`${pathname}`.startsWith('/Plans')) {
        pathname = `/plans${`${pathname}`.slice('/Plans'.length)}`;
    }

    if (`${pathname}`.startsWith('/Privacy')) {
        pathname = `/privacy${`${pathname}`.slice('/Privacy'.length)}`;
    }

    const params = new URLSearchParams(search || '');

    if (`${pathname}`.startsWith('/reader')) {
        const verse = params.get('verse');
        if (!verse) return '/';
        return buildReadPath(verse);
    }

    if (`${pathname}`.startsWith('/book')) {
        const ref = params.get('ref') || params.get('verse');
        return ref ? normalizePathname(`/book/${ref}`) : '/book';
    }

    if (`${pathname}`.startsWith('/people')) {
        const rec = params.get('rec');
        return rec ? normalizePathname(`/person/${rec}`) : '/people';
    }

    if (`${pathname}`.startsWith('/places') || `${pathname}`.startsWith('/place')) {
        const rec = params.get('rec');
        return rec ? normalizePathname(`/location/${rec}`) : '/places';
    }

    if (`${pathname}`.startsWith('/location/')) {
        return normalizePathname(pathname);
    }

    if (`${pathname}`.startsWith('/plans')) {
        const dev = params.get('dev');
        if (dev) {
            return buildPlansPath(dev);
        }

        const normalizedPath = normalizePathname(pathname);
        if (normalizedPath === '/plans') return '/plans';
        const planMatch = normalizedPath.match(/^\/plans\/(.+)$/);
        if (!planMatch) return normalizedPath;

        const resolvedPlanName = resolvePlanName(planMatch[1]);
        return resolvedPlanName ? buildPlansPath(resolvedPlanName) : normalizedPath;
    }

    return normalizePathname(pathname);
}
